export default "__VITE_ASSET__BmGO8m2E__"